import { BasePlugin } from '../base'
import mdcRadio from './mdc-radio.vue'

export { mdcRadio }

export default BasePlugin({
  mdcRadio
})
